export default __webpack_public_path__ + "static/media/IMG-20240729-WA0023.a1b1c702.jpg";